import { makeStyles, createStyles } from '@material-ui/core'

export const styles = theme => createStyles({
  option: {
    marginBottom: 0,
  },
  optionLabel: {
    fontFamily: 'Roboto-Regular',
  },
  label: {
    marginBottom: '1em'
  }
});

export default makeStyles(styles)